import { render, staticRenderFns } from "./examTopicDialog.vue?vue&type=template&id=40c3751c"
import script from "./examTopicDialog.vue?vue&type=script&lang=js"
export * from "./examTopicDialog.vue?vue&type=script&lang=js"
import style0 from "./examTopicDialog.vue?vue&type=style&index=0&id=40c3751c&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports